<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterResume"
              :editedCustomerIndex="-1"
              :customerName="'quotation_shortname'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterResume.LicensePlate"
              @input="getResume"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="ResumeDataTableHeaders"
      :items="resumeList"
      class="elevation-1 my-5"
      :loading="isLoadingResume"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('init_resume_tool_bar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowResumeDialog" fullscreen persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2 ml-8" v-bind="attrs" v-on="on">
                {{ $t('init_resume_new_btn') }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ initResumeDialogTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <ValidationObserver ref="resume">
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <customer-autocomplete
                          :fatherEditedCustomer="editedResume"
                          :editedCustomerIndex="-1"
                          :customerName="'quotation_customer_number'"
                          @setCustomer="setCustomer"
                          v-if="editedResumeIndex === -1"
                          refName="customerAutocomplete"
                          @keyupEnter="focusNextInput"
                        />
                        <ValidationProvider
                          :name="$t('quotation_customer_number')"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedResume.CustomerNumber"
                            :error-messages="errors[0]"
                            disabled
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_customer_number') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('quotation_shortname')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedResume.CustomerName"
                            :error-messages="errors[0]"
                            disabled
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_shortname') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('quotation_full_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedResume.CustomerFullName"
                            :error-messages="errors[0]"
                            disabled
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_full_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <ValidationProvider
                          :name="$t('quotation_license_plate')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model.trim="editedResume.LicensePlate"
                            :disabled="editedResumeIndex !== -1"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_license_plate') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <v-autocomplete
                          :items="allSpecialNeedList"
                          item-text="Name"
                          item-value="Name"
                          :label="$t('quotation_special_need')"
                          v-model="editedResume.SpecialNeedList"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          small-chips
                          multiple
                          return-object
                          @keydown.enter="setKeyDownAutocomplete"
                          @keyup.enter="setKeyUpAutocomplete"
                          ref="specialNeedAutocomplete"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedResume.Brand"
                          @keyup.enter="focusNextInput"
                          label="廠牌/車型"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                        {{ $t('engineer_first_contact') }}
                      </v-col>
                      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedResume.FirstContactName"
                          :label="$t('installation_notice_contact_name')"
                          @keyup.enter="focusNextInput"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedResume.FirstContactPhone"
                          :label="$t('installation_notice_contact_name')"
                          @keyup.enter="focusNextInput"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                        {{ $t('engineer_second_contact') }}
                      </v-col>
                      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedResume.SecondContactName"
                          :label="$t('installation_notice_contact_name')"
                          @keyup.enter="focusNextInput"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedResume.SecondContactPhone"
                          :label="$t('installation_notice_contact_name')"
                          @keyup.enter="focusNextInput"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                        {{ $t('engineer_third_contact') }}
                      </v-col>
                      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedResume.ThirdContactName"
                          :label="$t('installation_notice_contact_name')"
                          @keyup.enter="focusNextInput"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                        <v-text-field
                          v-model="editedResume.ThirdContactPhone"
                          :label="$t('installation_notice_contact_name')"
                          @keyup.enter="focusNextInput"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-data-table
                :headers="ResumeItemDataTableHeaders"
                :items="editedResume.ResumeItems"
                class="elevation-1 mx-5"
                :loading-text="$t('common_get_data')"
                :no-data-text="$t('common_no_data')"
                :no-results-text="$t('common_no_results')"
                :footer-props="{
                  'items-per-page-options': [30, 50, 100],
                  'items-per-page-text': $t('item_rows_per_page'),
                }"
                :header-props="headerProps"
                :search="searchResumeItem"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>{{ $t('init_resume_item_tool_bar_title') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchResumeItem"
                      append-icon="mdi-magnify"
                      :label="$t('resume_item_search_label')"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2 ml-8"
                      @click="isShowResumeItemDialog = true"
                    >
                      {{ $t('init_resume_item_new_btn') }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2 ml-8"
                      @click="isShowEditInitResumeBomDialog = true"
                    >
                      {{ $t('quotation_item_new_install_new_bom_btn') }}
                    </v-btn>
                    <v-dialog
                      v-model="isShowResumeItemDialog"
                      v-if="isShowResumeItemDialog"
                      max-width="1000px"
                      persistent
                    >
                      <v-card>
                        <v-card-title>
                          <span class="text-h5">{{ initResumeItemDialogTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <ValidationObserver ref="resumeItem">
                              <v-row>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <resume-item-filter-type-autocomplete
                                    :fatherEditedItem="editedResumeItem"
                                    :editedItemIndex="editedResumeItemIndex"
                                    :itemName="'quotation_item_name'"
                                    @setEditedItem="setEditedItem"
                                    :isAllTextFieldDisable="false"
                                    v-if="editedResumeItemIndex === -1 && isShowResumeItemDialog"
                                    refName="itemAutocomplete"
                                    @keyupEnter="focusNextInput"
                                  />
                                  <ValidationProvider
                                    :name="$t('quotation_item_number')"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-else
                                  >
                                    <v-text-field
                                      v-model="editedResumeItem.Number"
                                      disabled
                                      :error-messages="errors[0]"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('quotation_item_number') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <ValidationProvider
                                    :name="$t('quotation_item_name')"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <v-text-field
                                      v-model="editedResumeItem.Name"
                                      disabled
                                      required
                                      :error-messages="errors[0]"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('quotation_item_name') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <ValidationProvider
                                    :name="$t('quotation_item_quantity')"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <v-text-field
                                      v-model="editedResumeItem.Quantity"
                                      required
                                      @keyup.enter="focusNextInput"
                                      :error-messages="errors[0]"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('quotation_item_quantity') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <ValidationProvider
                                    :name="$t('quotation_item_unit')"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <v-text-field
                                      v-model="editedResumeItem.Unit"
                                      required
                                      disabled
                                      :error-messages="errors[0]"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('quotation_item_unit') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model.trim="editedResumeItem.OriginalLicensePlate"
                                    :label="$t('quotation_original_license_plate')"
                                    required
                                    @keyup.enter="focusNextInput"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <ValidationProvider
                                    :name="$t('installation_notice_item_buy_or_rent')"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <v-autocomplete
                                      v-model="editedResumeItem.BuyOrRentType"
                                      :items="allBuyOrRentType"
                                      item-text="Name"
                                      item-value="Type"
                                      required
                                      :loading-text="$t('common_get_data')"
                                      :no-data-text="$t('common_no_results')"
                                      @keyup.enter="setBuyOrRentTypeAutocomplete"
                                      ref="buyOrRentTypeAutocomplete"
                                      :error-messages="errors[0]"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('installation_notice_item_buy_or_rent') }}
                                      </template>
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="3"
                                  lg="3"
                                  xl="3"
                                  v-if="editedResumeItem.HasSerialNumber"
                                >
                                  <v-autocomplete
                                    v-model="editedResumeItem.SerialNumber"
                                    :items="serialNumberList"
                                    item-text="Number"
                                    item-value="Number"
                                    required
                                    return-object
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    @keyup.enter="setSerialNumberAutocomplete"
                                    ref="serialNumberAutocomplete"
                                    v-if="editedResumeIndex === -1"
                                    :label="$t('quotation_item_serialnumber')"
                                  >
                                  </v-autocomplete>
                                  <v-text-field
                                    v-model="editedResumeItem.SerialNumber.Number"
                                    :label="$t('quotation_item_serialnumber')"
                                    disabled
                                    v-else-if="editedResumeIndex !== -1"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <v-autocomplete
                                    v-model="editedResumeItem.InstallPosition"
                                    :items="allInstallPositionType"
                                    item-text="Name"
                                    item-value="Type"
                                    :label="$t('quotation_item_install_position')"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    @keyup.enter="setInstallPositionAutocomplete"
                                    ref="installPositionAutocomplete"
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="3"
                                  lg="3"
                                  xl="3"
                                  v-if="editedResumeItem.BuyOrRentType === 1"
                                >
                                  <date-picker-set-time
                                    :time="editedResumeItem.BuyStartDate"
                                    :dateName="'resume_item_buy_start'"
                                    :isAllTextFieldDisabled="false"
                                    @setDate="setBuyStartDate"
                                    @keyupEnter="focusNextInput"
                                  />
                                  <!-- <v-text-field
                                  v-model="computeBuyStartDate"
                                  :label="$t('resume_item_buy_start')"
                                  required
                                  disabled
                                  v-else
                                ></v-text-field> -->
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="3"
                                  lg="3"
                                  xl="3"
                                  v-if="editedResumeItem.BuyOrRentType === 1"
                                >
                                  <date-picker-set-time
                                    :time="editedResumeItem.BuyEndDate"
                                    :dateName="'resume_item_buy_end'"
                                    :isAllTextFieldDisabled="false"
                                    @setDate="setBuyEndDate"
                                    @keyupEnter="focusNextInput"
                                  />
                                  <!-- <v-text-field
                                  v-model="computeBuyEndDate"
                                  :label="$t('resume_item_buy_end')"
                                  required
                                  disabled
                                  v-else
                                ></v-text-field> -->
                                </v-col>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <date-picker-set-time-not-request
                                    :time="editedResumeItem.RemoveDate"
                                    :dateName="'resume_item_remove_date'"
                                    :isAllTextFieldDisabled="false"
                                    @setDate="setRemoveDate"
                                    @keyupEnter="focusNextInput"
                                  />
                                  <!-- <v-text-field
                                  v-model="computeRemoveDate"
                                  :label="$t('resume_item_remove_date')"
                                  required
                                  disabled
                                  v-else
                                ></v-text-field> -->
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <v-autocomplete
                                    v-model="editedResumeItem.Custody"
                                    :items="allCustodyType"
                                    item-text="Name"
                                    item-value="Type"
                                    :label="$t('resume_item_custody')"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    @keyup.enter="setCustodyAutocomplete"
                                    ref="custodyTypeAutocomplete"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <v-checkbox
                                    v-model="editedResumeItem.IsCustomerDevice"
                                    :label="$t('quotation_item_is_customer_device')"
                                    @change="changeIsCustomerDevice"
                                  ></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                  <v-autocomplete
                                    v-model="editedResumeItem.CustomerDeviceType"
                                    :items="customerDeviceTypeList"
                                    item-text="Name"
                                    item-value="Type"
                                    label="客戶設備類型"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    v-if="editedResumeItem.IsCustomerDevice"
                                    @keyup.enter="setCustomerDeviceTypeAutocomplete"
                                    ref="deviceTypeAutocomplete"
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                            </ValidationObserver>
                          </v-container>
                        </v-card-text>
                        <v-data-table
                          :headers="resumeItemProcessesDataTableHeaders"
                          :items="editedResumeItem.Processes"
                          class="elevation-1 mx-5"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_data')"
                          :no-results-text="$t('common_no_results')"
                          :footer-props="{
                            'items-per-page-options': [30, 50, 100],
                            'items-per-page-text': $t('item_rows_per_page'),
                          }"
                          :header-props="headerProps"
                          :search="searchResumeItemProcess"
                        >
                          <template v-slot:top>
                            <v-toolbar flat>
                              <v-toolbar-title>{{
                                $t('resume_item_process_card_title')
                              }}</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="searchResumeItemProcess"
                                append-icon="mdi-magnify"
                                :label="$t('resume_item_process_search_label')"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-toolbar>
                          </template>
                          <template v-slot:[`item.StartTime`]="{ item }">
                            {{ convertToDateTimeFormat(item.StartTime) }}
                          </template>
                          <template v-slot:[`item.EndTime`]="{ item }">
                            {{ convertToDateTimeFormat(item.EndTime) }}
                          </template>
                          <template v-slot:[`item.CreateDate`]="{ item }">
                            {{ convertToDateTimeFormat(item.CreateDate) }}
                          </template>
                          <template v-slot:[`item.OriginalNumberType`]="{ item }">
                            {{ turnNumberTypeData(item.OriginalNumberType) }}
                          </template>
                          <template v-slot:[`item.NumberType`]="{ item }">
                            {{ turnNumberTypeData(item.NumberType) }}
                          </template>
                          <template v-slot:[`item.WorkType`]="{ item }">
                            {{ turnWorkTypeName(item.WorkType) }}
                          </template>
                        </v-data-table>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" text @click="closeEditedResumeItem">
                            {{ $t('common_cancel') }}
                          </v-btn>
                          <v-btn color="green darken-1" text @click="addEditedResumeItem">
                            {{ $t('common_confirm') }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <delete-dialog
                      :isAllTextFieldDisable="false"
                      :isLoadingSaveBtn="false"
                      :isShowDeleteDialog="isShowDeleteResumeItemDialog"
                      :deleteMessage="'installation_acceptance_item_delete_dialog_message'"
                      @closeDelete="closeDeleteResumeItem"
                      @confirmDelete="confirmDeleteResumeItem"
                    />
                  </v-toolbar>
                </template>
                <!-- <template v-slot:[`item.UpdateTime`]="{ item }">
                {{ convertToDateTimeFormat(item.UpdateTime) }}
                </template> -->
                <template v-slot:[`item.Edit`]="{ item }">
                  <v-btn icon @click="isShowEditedResumeItemBtn(item)">
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn icon @click="isShowDeleteResumeItemDialogBtn(item)">
                    <v-icon small>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
                <template v-slot:[`item.InstallPosition`]="{ item }">
                  {{ turnData(item.InstallPosition) }}
                </template>
                <template v-slot:[`item.RemoveDate`]="{ item }">
                  {{ convertToDateTimeFormat(item.RemoveDate) }}
                </template>
                <template v-slot:[`item.BuyStartDate`]="{ item }">
                  {{ convertToDateTimeFormat(item.BuyStartDate) }}
                </template>
                <template v-slot:[`item.BuyEndDate`]="{ item }">
                  {{ convertToDateTimeFormat(item.BuyEndDate) }}
                </template>
                <template v-slot:[`item.BuyOrRentType`]="{ item }">
                  {{ turnBuyOrRentType(item.BuyOrRentType) }}
                </template>
                <template v-slot:[`item.Custody`]="{ item }">
                  {{ turnCustodyTypeData(item.Custody) }}
                </template>
                <template v-slot:[`item.CustomerDeviceType`]="{ item }">
                  {{ turnCustomerDeviceTypeData(item.CustomerDeviceType) }}
                </template>
              </v-data-table>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeEditedResume">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="green darken-1" text @click="saveEditedResumeItem">
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="isShowEditInitResumeBomDialog" persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ initResumeDialogTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                      <ValidationObserver ref="resumeItemBom">
                        <ValidationProvider
                          :name="$t('quotation_item_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-autocomplete
                            v-model="editedInitResumeBomItem"
                            :items="bomList"
                            item-text="Name"
                            item-value="Id"
                            :label="$t('quotation_item_name')"
                            required
                            return-object
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_item_name') }}
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.Name }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ data.item.Describe }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </ValidationObserver>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="isShowEditInitResumeBomDialog = false">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="green darken-1" text @click="addInitResumeBomItem">
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- <template v-slot:[`item.UpdateTime`]="{ item }">
      {{ convertToDateTimeFormat(item.UpdateTime) }}
    </template> -->
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditedResumeBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <!-- <v-icon
        small
        @click="isShowDeleteResumeDialogBtn(item)"
      >
        mdi-delete
      </v-icon> -->
      </template>
      <template v-slot:[`item.SpecialNeedList`]="{ item }">
        {{ turnSpecialNeedName(item.SpecialNeedList) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  HttpResume,
  HttpInstallationAcceptance,
  HttpQuotation,
  HttpSpecialNeed,
  HttpBom,
  HttpSerialNumber,
  HttpFix,
  HttpInstallPosition
} from '@/js/http-Manager'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import axios from 'axios'
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { NumberType } from '@/js/NumberType'
import ResumeItemFilterTypeAutocomplete from '@/components/ResumeItemFilterTypeAutocomplete.vue'
import { CustodyType } from '@/js/CustodyType'
import DatePickerSetTime from '@/components/DatePickerSetTime.vue'
import { CustomerDeviceType } from '@/js/CustomerDeviceType'
import { WorkType } from '@/js/WorkType'
import DatePickerSetTimeNotRequest from '@/components/DatePickerSetTimeNotRequest.vue'

export default {
  components: {
    CustomerAutocomplete,
    CustomerAutocompleteFilter,
    DeleteDialog,
    ResumeItemFilterTypeAutocomplete,
    DatePickerSetTime,
    DatePickerSetTimeNotRequest
  },
  name: 'Resume',
  data: () => ({
    filterResume: {
      CustomerId: '',
      LicensePlate: ''
    },
    isShowResumeDialog: false,
    resumeList: [],
    editedResumeIndex: -1,
    searchResume: '',
    editedResume: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      ResumeItems: [],
      SpecialNeedList: [],
      Brand: ''
    },
    defaultResume: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      ResumeItems: [],
      SpecialNeedList: [],
      Brand: ''
    },
    isLoadingResume: true,
    totalRows: 0,
    isUpdateEventTotal: true,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    editedResumeItem: {
      BomName: '',
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      BuyOrRentType: 0,
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      IsCustomerDevice: false,
      InstallPosition: 0,
      RemoveDate: 0,
      BuyStartDate: 0,
      BuyEndDate: 0,
      OriginalLicensePlate: '',
      Custody: 0,
      Remark: '',
      HasSerialNumber: false,
      CustomerDeviceType: 0,
      Processes: []
    },
    defaultResumeItem: {
      BomName: '',
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      BuyOrRentType: 0,
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      IsCustomerDevice: false,
      InstallPosition: 0,
      RemoveDate: 0,
      BuyStartDate: 0,
      BuyEndDate: 0,
      OriginalLicensePlate: '',
      Custody: 0,
      Remark: '',
      HasSerialNumber: false,
      CustomerDeviceType: 0,
      Processes: []
    },
    resumeSource: null,
    isLoadingItem: false,
    allBuyOrRentType: [],
    allInstallPositionType: [],
    isShowDeleteResumeItemDialog: false,
    searchResumeItem: '',
    isShowResumeItemDialog: false,
    searchResumeItemProcess: '',
    editedResumeItemIndex: -1,
    customerDeviceTypeList: [],
    allSpecialNeedList: [],
    specialNeedList: [],
    editedInitResumeBomItem: {
      Name: '',
      BomItems: []
    },
    defaultInitResumeBomItem: {
      Name: '',
      BomItems: []
    },
    isShowEditInitResumeBomDialog: false,
    bomList: [],
    serialNumberList: [],
    allCustodyType: []
  }),
  async mounted () {
    await this.getBuyOrRentType()
    await this.getAllInstallPositionType()
    await this.getResume()
    await this.countTotalRows()
    await this.getCustomerDeviceType()
    await this.getSpecialNeedList()
    await this.getAllBoms()
    await this.getAllCustodyType()
  },
  watch: {},
  computed: {
    computeRemoveDate () {
      return this.convertToDateTimeFormat(this.editedResumeItem.RemoveDate)
    },
    computeBuyStartDate () {
      return this.convertToDateTimeFormat(this.editedResumeItem.BuyStartDate)
    },
    computeBuyEndDate () {
      return this.convertToDateTimeFormat(this.editedResumeItem.BuyEndDate)
    },
    initResumeDialogTitle () {
      return this.editedResumeIndex === -1
        ? this.$t('init_resume_new_card_title')
        : this.$t('init_resume_edit_card_title')
    },
    initResumeItemDialogTitle () {
      return this.editedResumeItemIndex === -1
        ? this.$t('init_resume_item_new_card_title')
        : this.$t('init_resume_item_edit_card_title')
    },
    ResumeDataTableHeaders () {
      return [
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        {
          text: this.$t('quotation_special_need'),
          align: 'start',
          value: 'SpecialNeedList'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    ResumeItemDataTableHeaders () {
      return [
        { text: this.$t('installation_notice_item_main_name'), align: 'start', value: 'BomName' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'CustomerDeviceType'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        { text: this.$t('resume_item_remove_date'), align: 'start', value: 'RemoveDate' },
        { text: this.$t('resume_item_buy_start'), align: 'start', value: 'BuyStartDate' },
        { text: this.$t('resume_item_buy_end'), align: 'start', value: 'BuyEndDate' },
        {
          text: this.$t('quotation_original_license_plate'),
          align: 'start',
          value: 'OriginalLicensePlate'
        },
        { text: this.$t('resume_item_custody'), align: 'start', value: 'Custody' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    resumeItemProcessesDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber'
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'start',
          value: 'CustomerName'
        },
        {
          text: this.$t('quotation_full_name'),
          align: 'start',
          value: 'CustomerFullName'
        },
        {
          text: '回寫單據單別',
          align: 'start',
          value: 'OriginalNumberType'
        },
        {
          text: this.$t('resume_item_process_original_number'),
          align: 'start',
          value: 'OriginalNumber'
        },
        { text: this.$t('resume_item_process_quantity'), align: 'start', value: 'Quantity' },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        { text: this.$t('resume_item_process_create_date'), align: 'start', value: 'CreateDate' },
        {
          text: this.$t('resume_item_process_number_type'),
          align: 'start',
          value: 'NumberType'
        },
        {
          text: this.$t('resume_item_process_flow_original_number'),
          align: 'start',
          value: 'FlowOriginalNumber'
        },
        {
          text: this.$t('resume_item_buy_start'),
          align: 'start',
          value: 'StartTime'
        },
        {
          text: this.$t('resume_item_buy_end'),
          align: 'start',
          value: 'EndTime'
        },
        {
          text: this.$t('engineer_item_work_type'),
          align: 'start',
          value: 'WorkType'
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    async getAllCustodyType () {
      let response = await HttpFix.GetCustodyType()
      this.allCustodyType = response.status === 200 ? response.data.Data : []
    },
    async getSerialNumberFromItemId () {
      let response = await HttpSerialNumber.GetSerialNumberFromItemId({
        itemId: this.editedResumeItem.ItemId
      })
      this.serialNumberList = response.status === 200 ? response.data.Data : []
    },
    async addInitResumeBomItem () {
      const isValid = await this.$refs.resumeItemBom.validate()
      if (isValid) {
        for (var ele of this.editedResume.ResumeItems) {
          var index = 0
          for (var element of this.editedInitResumeBomItem.BomItems) {
            if (element.Number === ele.Number) {
              this.editedInitResumeBomItem.BomItems.splice(index, 1)
              break
            }
            index++
          }
        }
        if (this.editedInitResumeBomItem.BomItems.length !== 0) {
          this.editedInitResumeBomItem.BomItems.forEach((element) => {
            this.editedResume.ResumeItems.push({
              BomName: this.editedInitResumeBomItem.Name,
              BomId: this.editedInitResumeBomItem.Id,
              BomDescribe: this.editedInitResumeBomItem.Describe,
              ItemId: element.Id,
              Number: element.Number,
              Name: element.Name,
              Unit: element.Unit,
              Quantity: element.Quantity,
              BuyOrRentType: 0,
              SerialNumber: {
                ItemId: '',
                Number: '',
                IsUsed: false,
                AcceptanceNumber: '',
                RepairNumber: ''
              },
              IsCustomerDevice: false,
              InstallPosition: 0,
              RemoveDate: 0,
              BuyStartDate: 0,
              BuyEndDate: 0,
              OriginalLicensePlate: '',
              Custody: 0,
              Remark: '',
              HasSerialNumber: element.HasSerialNumber,
              CustomerDeviceType: 0,
              Processes: []
            })
          })
        }

        this.isShowEditInitResumeBomDialog = false
        let str = JSON.stringify(this.defaultInitResumeBomItem)
        this.editedInitResumeBomItem = JSON.parse(str)
      }
    },
    async getAllBoms () {
      let response = await HttpBom.GetAllBoms()
      this.bomList = response.status === 200 ? response.data.Data : []
    },
    setCustodyAutocomplete (event) {
      this.$refs.custodyTypeAutocomplete.isMenuActive = false
      this.$refs.custodyTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setCustomerDeviceTypeAutocomplete (event) {
      this.$refs.deviceTypeAutocomplete.isMenuActive = false
      this.$refs.deviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setInstallPositionAutocomplete (event) {
      this.$refs.installPositionAutocomplete.isMenuActive = false
      this.$refs.installPositionAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setSerialNumberAutocomplete (event) {
      this.$refs.serialNumberAutocomplete.isMenuActive = false
      this.$refs.serialNumberAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setBuyOrRentTypeAutocomplete (event) {
      this.$refs.buyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.buyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.specialNeedList = this.editedResume.SpecialNeedList
    },
    setKeyUpAutocomplete (event) {
      this.$refs.specialNeedAutocomplete.isMenuActive = false
      this.$refs.specialNeedAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedResume.SpecialNeedList = this.specialNeedList
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getSpecialNeedList () {
      let response = await HttpSpecialNeed.GetSpecialNeed()
      this.allSpecialNeedList = response.status === 200 ? response.data.Data : []
    },
    changeIsCustomerDevice () {
      this.editedResumeItem.CustomerDeviceType = 3
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    turnNumberTypeData (val) {
      return NumberType.NumberTypeName(val)
    },
    turnWorkTypeName (val) {
      return WorkType.getFormWorkTypeName(val)
    },
    turnCustomerDeviceTypeData (val) {
      return CustomerDeviceType.CustomerDeviceTypeName(val)
    },
    turnCustodyTypeData (val) {
      return CustodyType.CustodyTypeName(val)
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    setRemoveDate (val) {
      this.editedResumeItem.RemoveDate = val * 1
    },
    setBuyEndDate (val) {
      this.editedResumeItem.BuyEndDate = val * 1
    },
    setBuyStartDate (val) {
      this.editedResumeItem.BuyStartDate = val * 1
    },
    async setEditedItem (val) {
      this.editedResumeItem.ItemId = val.Id
      this.editedResumeItem.Number = val.Number
      this.editedResumeItem.Name = val.Name
      this.editedResumeItem.Unit = val.Unit
      this.editedResumeItem.Price = val.Price
      this.editedResumeItem.IsMonthItem = val.IsMonthItem
      this.editedResumeItem.IsDelete = val.IsDelete
      this.editedResumeItem.StoreNo = val.StoreNo
      this.editedResumeItem.RepairPrice = val.RepairPrice
      this.editedResumeItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedResumeItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedResumeItem.IsCustomerDevice = false
      this.editedResumeItem.HasSerialNumber = val.HasSerialNumber
      this.editedResumeItem = JSON.parse(JSON.stringify(this.editedResumeItem))
      await this.getSerialNumberFromItemId()
    },
    async setCustomer (val) {
      this.editedResume.CustomerId = val.Id
      this.editedResume.CustomerNumber = val.Number
      this.editedResume.CustomerName = val.ShortName
      this.editedResume.CustomerFullName = val.FullName
      this.editedResume = JSON.parse(JSON.stringify(this.editedResume))
    },
    async setFilterCustomer (val) {
      this.filterResume.CustomerId = val.Id
      this.filterResume = JSON.parse(JSON.stringify(this.filterResume))
      await this.getResume()
      await this.countTotalRows()
    },
    changeThing () {
      this.editedResumeItem.IsCustomerDevice = false
      this.editedResumeItem.RemoveDate = 0
      this.editedResumeItem.BuyStartDate = 0
      this.editedResumeItem.BuyEndDate = 0
      this.editedResumeItem.ItemId = this.editedResumeItem.Id
    },
    async saveEditedResumeItem () {
      const isValid = await this.$refs.resume.validate()
      if (isValid) {
        if (this.editedResumeIndex > -1) {
          await HttpResume.UpdateResume(this.editedResume)
        } else {
          await HttpResume.AddResume(this.editedResume)
        }

        await this.getResume()
        this.closeEditedResume()
      }
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          customerId: this.filterResume.CustomerId,
          licensePlate: this.filterResume.LicensePlate
        }
        let response = await HttpResume.GetResumeCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getResume(val)
    },
    async getResume (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingResume = true
      let param = {
        customerId: this.filterResume.CustomerId,
        licensePlate: this.filterResume.LicensePlate,
        perPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        sortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy[0],
        sortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy[0]
      }
      if (this.resumeSource) {
        this.resumeSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.resumeSource = cancelToken.source()
      let response = await HttpResume.GetResume(param, this.resumeSource.token)
      this.isLoadingResume = false
      if (response) {
        this.resumeList = response.status === 200 ? response.data.Data : []
        this.resumeSource = null
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditedResumeBtn (item) {
      this.editedResumeIndex = this.resumeList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedResume = JSON.parse(str)
      this.isShowResumeDialog = true
    },
    async closeEditedResume () {
      await this.getResume()
      this.isShowResumeDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultResume)
        this.editedResume = JSON.parse(str)
        this.editedResumeIndex = -1
      })
    },

    async isShowEditedResumeItemBtn (item) {
      this.editedResumeItemIndex = this.editedResume.ResumeItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedResumeItem = JSON.parse(str)
      await this.getSerialNumberFromItemId()
      this.isShowResumeItemDialog = true
    },
    async addEditedResumeItem () {
      const isValid = await this.$refs.resumeItem.validate()
      if (isValid) {
        if (this.editedResumeItemIndex > -1) {
          this.editedResume.ResumeItems.splice(
            this.editedResumeItemIndex,
            1,
            this.editedResumeItem
          )
        } else {
          this.editedResume.ResumeItems.push(this.editedResumeItem)
          this.editedResumeItem.Processes = []
        }
        this.editedResumeItem.Processes.push({
          OriginalNumber: '初始化',
          SerialNumber: this.editedResumeItem.SerialNumber,
          Quantity: this.editedResumeItem.Quantity,
          CreateDate: Date.parse(new Date()),
          NumberType: 7,
          FlowOriginalNumber: '初始化',
          CustomerId: this.editedResume.CustomerId,
          CustomerNumber: this.editedResume.CustomerNumber,
          CustomerName: this.editedResume.CustomerName,
          CustomerFullName: this.editedResume.CustomerFullName,
          WorkType: this.editedResumeItem.RemoveDate === 0 ? 2 : 1,
          StartTime: this.editedResumeItem.BuyStartDate,
          EndTime: this.editedResumeItem.BuyEndDate
        })
        this.closeEditedResumeItem()
      }
    },
    async closeEditedResumeItem () {
      this.isShowResumeItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultResumeItem)
        this.editedResumeItem = JSON.parse(str)
        this.editedResumeItemIndex = -1
      })
    },

    isShowDeleteResumeItemDialogBtn (item) {
      this.editedResumeItemIndex = this.editedResume.ResumeItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedResumeItem = JSON.parse(str)
      this.isShowDeleteResumeItemDialog = true
    },

    confirmDeleteResumeItem () {
      this.editedResume.ResumeItems.splice(this.editedResumeItemIndex, 1)
      this.closeDeleteResumeItem()
    },
    closeDeleteResumeItem () {
      this.isShowDeleteResumeItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultResumeItem)
        this.editedResumeItem = JSON.parse(str)
        this.editedResumeItemIndex = -1
      })
    },

    turnData (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.allInstallPositionType
        )
      }
    }
  }
}
</script>
